import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import Header from 'components/Header';
import Loading from 'components/Loading';
import styles from './index.less';
import { dateFormat } from 'utils/index';
import { getShowTopBar } from '../../utils/getValue';

const recordTopBackgroundColor = {
  undefined: 'linear-gradient(90deg, #ff3030 0%, #ff7947 100%)',
  pingan: '#FF4800',
};

const languageMap = {
  'zh-cn': {
    Title: '使用记录',
    Visit: '消费人数',
    Point: '消费点数',
  },
  en: {
    Title: 'My Visited Places',
    Visit: 'Visit(s)',
    Point: 'Point(s)',
  },
};

@connect(({ record, loading }) => ({
  list: record.list,
  pages: record.pages,
  loading: loading.effects['record/init'],
}))
class Record extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 1,
      pageSize: 10,
      refreshing: true,
      hasMore: false,
    };
  }

  componentDidMount() {
    const { language } = (this.props.location && this.props.location.query) || {};
    this.props.dispatch({
      type: 'record/init',
      payload: {
        language,
        dragoncode: localStorage.getItem('dragoncode'),
        pageNo: this.state.pageNo,
        pageSize: this.state.pageSize,
      },
    });
    window.addEventListener('scroll', this.bindScroll.bind(this));
  }

  componentWillUnmount() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.bindScroll.bind(this));
  }

  requestData(pageNo, pageSize) {
    const { language } = (this.props.location && this.props.location.query) || {};
    this.props.dispatch({
      type: 'record/queryRecordList',
      payload: {
        language,
        dragoncode: localStorage.getItem('dragoncode'),
        pageNo,
        pageSize,
      },
    });
  }

  // 下拉刷新
  bindScroll(event) {
    const { pages } = this.props;
    const { pageNo, pageSize, refreshing } = this.state;

    // 滚动的高度
    const scrollTop =
      (event.srcElement ? event.srcElement.documentElement.scrollTop : false) ||
      window.pageYOffset ||
      (event.srcElement ? event.srcElement.body.scrollTop : 0);
    // 视窗高度
    const clientHeight =
      (event.srcElement && event.srcElement.documentElement.clientHeight) ||
      document.body.clientHeight;
    // 页面高度
    const scrollHeight =
      (event.srcElement && event.srcElement.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    // 距离页面底部的高度
    const height = scrollHeight - scrollTop - clientHeight;
    // 判断距离页面底部的高度
    if (pageNo < pages && height <= 1) {
      // console.log('当前current:' + pageNo);
      // 判断执行回调条件
      if (refreshing) {
        this.setState({ refreshing: false, pageNo: pageNo + 1 }, () => {
          console.log(2222, pageNo);
          this.requestData(pageNo + 1, pageSize);
          setTimeout(() => {
            this.setState({
              refreshing: true,
            });
          }, 500);
        });
      }
    } else {
      // 打开判断执行开关
      this.setState({
        refreshing: true,
      });
    }

    if (pageNo < pages) {
      this.setState({ hasMore: true });
    } else {
      this.setState({ hasMore: false });
    }
  }

  render() {
    const { list, loading } = this.props;
    const { hasMore } = this.state;
    const lg = localStorage.getItem('language') || 'zh-cn';
    const channel = localStorage.getItem('channel');
    const showTopBar = getShowTopBar();
    const showPoint = channel !== 'bjsh';
    return (
      <Fragment>
        <Header title={languageMap[lg].Title} />

        <Loading loading={loading}>
          <div
            className="innerContent"
            style={{
              paddingTop: showTopBar ? '1rem' : '0',
            }}
          >
            {list.length > 0 ? (
              <div className={styles.recordWrap}>
                {list.map((item, index) => {
                  return (
                    <div className={styles.block} key={index}>
                      <div
                        className={styles.recordTop}
                        style={{
                          background: recordTopBackgroundColor[channel],
                        }}
                      >
                        <div className={styles.center}>
                          <span className={styles.left}>
                            {dateFormat('YYYY-mm-dd HH:MM:SS', item.createTime)}
                          </span>
                          <span className={styles.right}>NO：{item.transsequno}</span>
                        </div>
                      </div>
                      <div className={styles.recordBottom}>
                        <div className={styles.bottomCenter}>
                          <div className={styles.item} style={{ width: '4rem' }}>
                            <div className={styles.name}>{item.airportName}</div>
                            <div className={styles.lounge}>{item.loungeName}</div>
                            <div className={styles.type}>LOUNGE</div>
                          </div>
                          <div className={styles.item} style={{ width: '1.3rem' }}>
                            <div className={styles.name} style={{ textAlign: 'center' }}>
                              {item.personCount}
                            </div>
                            <div className={styles.lounge} style={{ textAlign: 'center' }}>
                              {languageMap[lg].Visit}
                            </div>
                            <div className={styles.type} style={{ textAlign: 'center' }}>
                              PEOPLE
                            </div>
                          </div>
                          <div
                            className={styles.item}
                            style={{
                              width: '1.4rem',
                              borderLeft: '.02rem #F0F0F0 solid',
                              display: showPoint ? 'block' : 'none',
                            }}
                          >
                            <div className={styles.name} style={{ textAlign: 'center' }}>
                              {item.point +
                                item.accountPoint +
                                item.buyPoint +
                                item.exchangePoint +
                                item.freePoint}
                            </div>
                            <div className={styles.lounge} style={{ textAlign: 'center' }}>
                              {languageMap[lg].Point}
                            </div>
                            <div className={styles.type} style={{ textAlign: 'center' }}>
                              PONINTS
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className={styles.recordTip}>{hasMore ? '下滑加载更多' : '没有更多了'}</div>
              </div>
            ) : (
              <div className={styles.none}>
                <img src={require('images/none_record.png')} alt="" />
                <p>暂无消费记录</p>
              </div>
            )}
          </div>
        </Loading>
      </Fragment>
    );
  }
}

export default Record;
